module.exports = __webpack_public_path__ + "static/media/21.ea98330c.mp3";